/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IConnectionRoomGroup {
        id?: number;
        connectionRoomId?: number;
        name?: string;
        connectionRoomGroupBlocks?: number[];
        blocksInfo?: IBlock[];
    }

    export class ConnectionRoomGroup implements IConnectionRoomGroup {
        public id?: number;
        public connectionRoomId?: number;
        public name?: string;
        public connectionRoomGroupBlocks?: number[];
        public blocksInfo?: IBlock[];

        public static Empty(): ConnectionRoomGroup {
            return new ConnectionRoomGroup();
        }

        constructor() {
            // empty constructor
            this.name = '';
            this.connectionRoomGroupBlocks = [];
        }
    }
}
